interface IChangedCustomElement {
  idx: number;
  value: any;
}
interface HtmlControlDefinition {
    type: string;
    id?: string;
    name?: string;
    label?: string;
    value?: string;
    attributes?: Record<string, string>;
    children?: HtmlControlDefinition[];
}

type HtmlElementPropertyType = 'string' | 'boolean' | 'number' | 'array' | 'any';

interface HtmlElementProperty {
    name: string;
    type: HtmlElementPropertyType;
    value?: any;
}

const HtmlElementsProperties: HtmlElementProperty[] = [
    { name: 'name', type: 'string' },
    { name: 'inputType', type: 'string' },
    { name: 'required', type: 'boolean' },
    { name: 'disabled', type: 'boolean' },
    { name: 'visible', type: 'boolean' },
    { name: 'maximo', type: 'string' },
    { name: 'label', type: 'string' },
    { name: 'options', type: 'array' },
    { name: 'optionsJSON', type: 'array' },
    { name: 'equal', type: 'string' },
    { name: 'format', type: 'string' },
    { name: 'dependence', type: 'string' },
    { name: 'referenceDepedence', type: 'string' },
    { name: 'referenceName', type: 'string' },
];

interface HtmlElement {
    idx: number;
    name: string;
    properties: string[];
}

const HtmlElements: HtmlElement[] = [
    {
        idx:0,
        name: 'input',
        properties: ['inputType', 'name', 'label', 'visible', 'required', 'maximo', 'equal']
    },
    {
        idx:1,
        name: 'select',
        properties: ['name', 'label', 'visible', 'required', 'options', 'optionsJSON']
    },
    {
        idx:2,
        name: 'checkbox',
        properties: ['name', 'label', 'visible', 'required', 'referenceName' ,'referenceDepedence']
    },
    {
        idx:3,
        name: 'textarea',
        properties: ['inputType', 'name', 'label', 'visible', 'required', 'maximo', 'format', 'equal', 'dependence']
    },
    {
        idx:4,
        name: 'radiobutton',
        properties: ['name', 'label', 'visible', 'required', 'options', 'optionsJSON']
    },
    {
        idx:5,
        name: 'div',
        properties: ['inputType', 'name', 'label', 'visible', 'required', 'maximo', 'equal', 'dependence', 'options', 'optionsJSON', 'format']
    }

];

class HtmlElementParser {

    //private elements: HtmlElement[];

    getElements() {

        return HtmlElements.map(e => (
            { 
                ...e,
                properties: e.properties.map(property => 
                    HtmlElementsProperties.filter(p => p.name === property)[0])
            }
        ));

    }

    
    parseElements(elements: any[]) {

        return elements.map((e,idx) => (
            
            /// en algunos casos el type es text en vez de input
            e['type'] = e['type'] === 'text' ? 'input' : e['type'],

            JSON.parse(JSON.stringify({ 
                idx: idx,
                name: e['type'],
                properties: this.buildElementsProperties(e),
            }))
        ));

        // return el;

    }

    buildElementsProperties(element: any): HtmlElementProperty[] {
        let properties: HtmlElementProperty[] = [];
        // nos quedamos con un template del tipo elemento
        const e = this.getElements().find(e => e.name === element.type);
        if (e)
            properties = e.properties.map(property => {
                property.value = element[property.name];
                return property;
            })  

        return properties;
    } 

    exportElements(elements: any[]) {

        let el: any[] = [];
        elements.forEach(e => {
            let element: any = { type: e.name };
            e.properties.forEach(p => {
                element[p['name']] = p['value'];
            });
            el.push(element);
        });

        //console.log('exported',el);

        return el;
    }


    parse(jsonString: string): HtmlControlDefinition[] {
        try {
            const data = JSON.parse(jsonString);
            return Array.isArray(data) ? data : [data];
        } catch (error) {
            throw new Error(`Error parsing JSON: ${error}`);
        }
    }

    //not used
    createElement(definition: HtmlControlDefinition): HTMLElement {
        const element = document.createElement(definition.type);

        if (definition.id) element.id = definition.id;
        if (definition.name) element.setAttribute('name', definition.name);
        if (definition.label) element.setAttribute('aria-label', definition.label);
        if (definition.value) element.setAttribute('value', definition.value);

        if (definition.attributes) {
            Object.entries(definition.attributes).forEach(([key, val]) => {
                element.setAttribute(key, val);
            });
        }

        if (definition.children) {
            definition.children.forEach(child => {
                element.appendChild(this.createElement(child));
            });
        }

        return element;
    }
}

export { IChangedCustomElement, HtmlElementParser, HtmlControlDefinition };